// extracted by mini-css-extract-plugin
export var closeButton = "_dh-1";
export var closeX = "_dh-3";
export var container = "_dh-0";
export var image = "_dh-2";